export default {
  reg: {
    letter: 'Apenas letras inglesas e espaços são permitidos',
  },
}
